/**
 * Auth Actions
 * Auth Action With Google, Facebook, Twitter and Github
 */
import {
    LOGIN_FACEBOOK_USER,
    LOGIN_GITHUB_USER,
    LOGIN_GOOGLE_USER,
    LOGIN_TWITTER_USER,
    LOGIN_USER,
    LOGIN_USER_FAILURE,
    LOGIN_USER_SUCCESS,
    LOGIN_WITH_EXTERNAL_SERVICE,
    LOGOUT_USER,
    LOGOUT_USER_FAILURE,
    LOGOUT_USER_SUCCESS,
    SET_REGISTRATION_EMAIL,
    SIGNUP_USER,
    SIGNUP_USER_FAILURE,
    SIGNUP_USER_SUCCESS,
} from './types';

/**
 * Redux Action To Sigin User
 */
export const signinUserInBackend = (user, history) => ({
    type: LOGIN_USER,
    payload: {user, history},
});

/**
 * Redux Action Signin User Success
 */
export const signinUserSuccess = (user) => ({
    type: LOGIN_USER_SUCCESS,
    payload: user,
});

/**
 * Redux Action To Signup User Success
 */
export const signUpUserSuccess = (user) => ({
    type: SIGNUP_USER_SUCCESS,
    payload: user,
});

/**
 * Redux Action To Signup User Failure
 */
export const signUpUserFailure = (error) => ({
    type: SIGNUP_USER_FAILURE,
    payload: error,
});

/**
 * Redux Action Signin User Failure
 */
export const signinUserFailure = (error) => ({
    type: LOGIN_USER_FAILURE,
    payload: error,
});

/**
 * Redux Action To Signout User
 */
export const logoutUser = (redirectTo) => ({
    type: LOGOUT_USER,
    payload: {redirectTo},
});

/**
 * Redux Action Signout User Success
 */
export const logoutUserSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
});

/**
 * Redux Action Signout User Failure
 */
export const logoutUserFailure = () => ({
    type: LOGOUT_USER_FAILURE,
});

/**
 * Redux Action To Signup User
 */
export const signupUser = (user, history) => ({
    type: SIGNUP_USER,
    payload: {user, history},
});

/**
 * Redux Action To Signin User With Facebook
 */
export const signinUserWithFacebook = (history) => ({
    type: LOGIN_FACEBOOK_USER,
    payload: history,
});

/**
 * Redux Action To Signin User With Google
 */
export const signinUserWithGoogle = (payload) => ({
    type: LOGIN_GOOGLE_USER,
    payload: payload,
});

export const signinUserWithExternalService = (payload) => ({
    type: LOGIN_WITH_EXTERNAL_SERVICE,
    payload: payload,
});

/**
 * Redux Action To Signin User With Github
 */
export const signinUserWithGithub = (history) => ({
    type: LOGIN_GITHUB_USER,
    payload: history,
});

/**
 * Redux Action To Signin User With Twitter
 */
export const signinUserWithTwitter = (history) => ({
    type: LOGIN_TWITTER_USER,
    payload: history,
});

export const setRegistrationEmail = (email) => ({
    type: SET_REGISTRATION_EMAIL,
    payload: email,
});